import { PermissionT } from "../types";

export const operationsManagement = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "operations_management");
  return !!p;
};

export default operationsManagement;
